import React from 'react';
import { KPI } from 'src/mtska-frontend-app-component';

const KPISet = ({ filters }) => {
    return (
        <>
            <KPI
                title="Vetture"
                dataProviderName={'statisticsviews/runningvehicles/count/cars/car'}
                filters={{
                    items: [
                        ...(filters?.items || [])
                    ]
                }}
            />
            <KPI
                title="Customers"
                dataProviderName={'statisticsviews/runningcustomers/countdistinct/cars/car/legal_entity_id'}
                filters={{
                    items: [
                        ...(filters?.items || [])
                    ]
                }}
            />
            <KPI
                title="Noleggiatori"
                dataProviderName={'statisticsviews/runningcustomers/countdistinct/cars/car/_related_renter_name'}
                filters={{
                    items: [
                        ...(filters?.items || [])
                    ]
                }}
            />
            <KPI
                title="Commissioni"
                dataProviderName={'statisticsviews/runningcustomers/sumfinancial/cars/car/_related_contract_commission'}
                format={'currency'}
                filters={{
                    items: [
                        ...(filters?.items || [])
                    ]
                }}
            />
        </>
    )
}

export default KPISet;